import React from 'react';

const PermissionGroupFormModal = React.lazy(() => import('../components/FormModal'));
const permissionGroupModalRegistry = {
    core_permissionGroupId: PermissionGroupFormModal
};
export default permissionGroupModalRegistry;
